import { render, staticRenderFns } from "./details.vue?vue&type=template&id=115e98c5&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"
import style0 from "./details.vue?vue&type=style&index=0&id=115e98c5&prod&lang=less&scoped=true"
import style1 from "./details.vue?vue&type=style&index=1&id=115e98c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e98c5",
  null
  
)

export default component.exports